const microwaveRepairService = {
  title: "Microwave Repair",
  icon: "🍲",
  rateCardKey: "microwave",
  shortDescription:
    "Microwave not heating, power issue, plate rotation issue, and inspection support.",
  longDescription:
    "Book microwave support for basic heating problems, startup issues, turntable problems, and general appliance diagnosis.",
  consultationNote:
    "Magnetron, PCB, fuse, and internal electrical issues require inspection before final quote.",
  responsePromise:
    "Assignment depends on model type and issue classification.",
  warrantyPolicy:
    "Support depends on internal component condition and repair feasibility.",
  subServices: [
    {
      id: "mw-inspection",
      title: "Microwave Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for not heating, not starting, sparking, or abnormal functioning.",
      basePrice: 249,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "mw-power-issue",
      title: "Power / Startup Issue",
      icon: "⚡",
      group: "Repair",
      description:
        "Basic diagnosis for startup issue, fuse issue symptoms, or intermittent power behavior.",
      basePrice: 349,
      priceType: "starts_at",
      duration: "30-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "mw-heating-issue",
      title: "Heating Issue Support",
      icon: "🔥",
      group: "Repair",
      description:
        "Check heating failure symptoms and assess repair direction.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "30-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "mw-turntable-issue",
      title: "Turntable / Plate Rotation Issue",
      icon: "🔄",
      group: "Repair",
      description:
        "Support for plate rotation problem or minor movement-related issue.",
      basePrice: 299,
      priceType: "starts_at",
      duration: "20-40 mins",
      warranty: "7 days",
      unit: "job",
    },
  ],
};

export default microwaveRepairService;